var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIc4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 64,
    height: 64,
    rx: 32,
    fill: "#EFF3FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.3333 22.9676V38.8209C45.3333 40.1142 44.28 41.3009 42.9867 41.4609L42.5733 41.5142C40.3867 41.8076 37.3067 42.7142 34.8267 43.7542C33.96 44.1142 33 43.4609 33 42.5142V23.9676C33 23.4742 33.28 23.0209 33.72 22.7809C36.16 21.4609 39.8533 20.2876 42.36 20.0742H42.44C44.04 20.0742 45.3333 21.3676 45.3333 22.9676Z",
    fill: "#002C8F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.28 22.7809C27.84 21.4609 24.1467 20.2876 21.64 20.0742H21.5467C19.9467 20.0742 18.6533 21.3676 18.6533 22.9676V38.8209C18.6533 40.1142 19.7067 41.3009 21 41.4609L21.4133 41.5142C23.6 41.8076 26.68 42.7142 29.16 43.7542C30.0267 44.1142 30.9867 43.4609 30.9867 42.5142V23.9676C30.9867 23.4609 30.72 23.0209 30.28 22.7809ZM22.6667 26.8209H25.6667C26.2133 26.8209 26.6667 27.2742 26.6667 27.8209C26.6667 28.3809 26.2133 28.8209 25.6667 28.8209H22.6667C22.12 28.8209 21.6667 28.3809 21.6667 27.8209C21.6667 27.2742 22.12 26.8209 22.6667 26.8209ZM26.6667 32.8209H22.6667C22.12 32.8209 21.6667 32.3809 21.6667 31.8209C21.6667 31.2742 22.12 30.8209 22.6667 30.8209H26.6667C27.2133 30.8209 27.6667 31.2742 27.6667 31.8209C27.6667 32.3809 27.2133 32.8209 26.6667 32.8209Z",
    fill: "#002C8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIc4);
export default __webpack_public_path__ + "static/media/ic4.c70092bbf2616ce2e158509b547e1b5a.svg";
export { ForwardRef as ReactComponent };